import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, watch } from "vue";
import { useModelValue } from "../../../../composables/useSyncProp";
import { QButton } from "../../../shared";
import { Category } from "../types/Category";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteCategoryModal',
  props: {
	value: {
		type: Boolean as PropType<boolean>,
		required: true,
	},
	category: {
		type: Object as PropType<Category>,
		required: true,
	},
},
  emits: ["ok", "input"],
  setup(__props, { emit }: { emit: ({
	(e: "ok", category: Category): void;
	(e: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props






const doShow = useModelValue(props, emit);

const deleteCategoryPermanently = () => true

return { __sfc: true,props, emit, doShow, deleteCategoryPermanently, QButton }
}

})